console.log('✅ buildComponentPageAccountStoreBankAccount loaded successfully!');

import { appState } from '../../../../js/state.js';

import { registerEventListenerToAttach } from '../../../../js/to-attach-event-listener-registry.js';
import { isNodeEnvironment } from '../../../../js/utils-fetch-data-json.js';

export async function buildComponentPageAccountStoreBankAccount() {
  console.log(
    `🔄 Building Component: buildComponentPageAccountStoreBankAccount - lang: ${appState.SiteLanguageCookie}`
  );

  try {
    const skeleton = await buildPageSkeleton();

    //By calling registerEventListenerToAttach() immediately, you wire up your hydration callback without delaying the paint.

    //registerEventListenerToAttach(async () => initbuildComponentPageAccountStoreBankAccount(params));
    registerEventListenerToAttach(initbuildComponentPageAccountStoreBankAccount);

    if (!isNodeEnvironment()) return skeleton;

    return await buildActualContent();

    return html;
  } catch (err) {
    console.error('❌ Error building buildComponentPageAccountStoreBankAccount:', err);
    return '<div>buildComponentPageAccountStoreBankAccount could not be loaded.</div>';
  }
}

export async function buildPageSkeleton() {
  // Top two “featured” cards
  const topCardsSkeletonHtml = `
      <br />
    <div class="grid-blog-home-bottom-section-card my-fake-image-height-250">
        <div class="my-site-lazy-loading-card">
            <div class="my-site-lazy-loading-card-movement"></div>
        </div>
    </div>
  `;

  let middleCardsSkeleton = '';
  for (let i = 0; i < 12; i++) {
    middleCardsSkeleton += `
      <div class="grid-blog-home-all-category-section-card my-fake-image-height-400">
                            <div class="my-site-lazy-loading-card">
                                <div class="my-site-lazy-loading-card-movement"></div>
                            </div>
                        </div>

                        
    `;
  }

  const html = `

    <div id="placeholder-buildComponentPageAccountStoreBankAccount">
  
   
    <center>

    <div class="myPageMargins">
       

                 ${middleCardsSkeleton}
       
    </div>

    </center>


     </div> 
    
   
  `;

  return html;
}

export async function initbuildComponentPageAccountStoreBankAccount() {
  try {
    console.log('✅ buildComponentPageAccountStoreBankAccount event listeners attached.');

    const container = document.querySelector(
      '#placeholder-buildComponentPageAccountStoreBankAccount'
    );
    if (!container) return;

    //This touches only the <div id="placeholder-…"> subtree. The rest of the page (header, footer, global scripts) is completely untouched, so the browser can preserve layout and styles. *** FYI Only - innerHTML result in the browser reflowing the entire page, which is expensive.
    container.outerHTML = await buildActualContent();
  } catch (error) {
    console.error(
      '❌ Error attaching event listeners to buildComponentPageAccountStoreBankAccount:',
      error
    );
  }
}

export async function buildActualContent() {
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "translation-service" */
    /* webpackPrefetch: true */
    '../../../../services/my-translator-service.js'
  );

  const {
    _tempTextTranslator: tTexts,
    _tempLinksTranslator: tLinks,
  } = await loadMyTranslationsService(appState.SiteLanguageCookie);

  // Build the HTML
  let html = `<div class="UserInfoContainer-CustomerView" data-attach-user-info>`;

  if (appState.MyBuyingEntityType === 'Business') {
    html += `
      <h3><a href="${tLinks.keyDashboard}">${tTexts.keyXampleBusinessStoreBankAccount}</a></h3>
      <label class="UserWelcomeMessage">${appState.MyBuyingEntityCompanyName}</label><br/>
      <a href="${tLinks.keyBusinessCompleteVerification}">${tTexts.keyCompleteVerification}</a>

      

      <h4>${tTexts.keyRolesNPermissions}</h4>
      <a href="${tLinks.keyBusinessUsers}">${tTexts.keyBusinessUsers}</a>
      <a href="${tLinks.keyBusinessRoles}">${tTexts.keyRoles}</a>
      <a href="${tLinks.keyBusinessUsersInRoles}">${tTexts.keyUsersInRoles}</a>

    
    `;
  } else {
    html += `
      <h3><a href="${tLinks.keyDashboard}">${tTexts.keyXamplePersonalStoreBankAccount}</a></h3><br/>

      <h3>${tTexts.keyMessages}</h3>
      <a href="${tLinks.keyMyMail}">${tTexts.keyMail}</a>
      <a href="${tLinks.keyMyStoreHome}">${tTexts.keyChat}</a>

  `;

    if (appState.UserHasAtLeastOneBuyingCompanyAccess) {
      html += `
        <a href="${tLinks.keySelectProfile}">${tTexts.keyChangeProfile}</a>
        <a href="${tLinks.keyMyCompanies}">${tTexts.keyAllMyCompanies}</a><br/>
      `;
    } else {
      html += `
        <a href="${tLinks.keyMyCompanies}">${tTexts.keyCreateBusinessAccount}</a><br/>
      `;
    }

    html += `<a href="logout">${tTexts.keyLogout}</a>`;
  }

  html += `
    </div>
    <a class="haveQuestionDiv" href="${tLinks.keyContactUs}">
      <div>${tTexts.keyHaveAQuestion}</div>
    </a>
  `;

  return html;
}

export async function buildComponentPageAccountStoreBankAccountHeaderTags() {
  const [{ fetchPageSEOTagsAsync }] = await Promise.all([
    import(
      /* webpackChunkName:"seo-data-service", webpackPrefetch: true */ '../../../../services/data-services/seo-data-service.js'
    ),
  ]);

  let result = '';

  const currentPageSEOAPIResult = await fetchPageSEOTagsAsync('KeyCategories');

  //alert("blogCategory: " + JSON.stringify(blogCategory));

  if (!currentPageSEOAPIResult) {
    console.log('❌ Error: page seo for buildComponentPageAccountStoreBankAccount not found');

    return result;
  }

  result = currentPageSEOAPIResult;

  return result;
}
